import React from "react";
import { Text, mergeStyles } from "@fluentui/react-northstar";
import { LinkProps } from "./Link.types";
import { useLinkStyles } from "./Link.styles";

export const Link: React.FC<LinkProps> = ({
  content,
  href,
  textProps,
  linkProps,
}) => {
  const { styles, ...restTextProps } = textProps ?? {};
  const { textStyles, linkStyles } = useLinkStyles();
  return (
    <Text
      content={
        <a href={href} style={linkStyles} {...linkProps}>
          {content}
        </a>
      }
      styles={styles ? mergeStyles(styles, textStyles) : textStyles}
      {...restTextProps}
    />
  );
};
